import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Divider,
	IconButton,
	Stack,
	Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { CloseIcon } from "../../../../../assets/icons";

type Props = {
	title: string;
	paragraphs?: string[];
	confirmText?: string;
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
};

export const DashboardAdvancedModeModal = ({ title, paragraphs, confirmText, open, onClose, onConfirm }: Props) => {
	const { t } = useTranslation("common");

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<Stack p={2} direction="row" justifyContent={"space-between"} alignItems={"center"}>
				<DialogTitle sx={{ p: 0 }}>{title}</DialogTitle>
				<IconButton aria-label="close" onClick={onClose}>
					{<CloseIcon />}
				</IconButton>
			</Stack>
			<Divider sx={{ mx: 2 }} />
			<DialogContent>
				<Stack spacing={2} px={2}>
					{paragraphs && (
						<ul style={{ padding: 0 }}>
							{paragraphs.map((p, index) => (
								<li key={index}>
									<Typography variant="body2">{p}</Typography>
								</li>
							))}
						</ul>
					)}
				</Stack>
			</DialogContent>
			<Divider sx={{ mx: 2 }} />
			<DialogActions sx={{ p: 2 }}>
				<Button onClick={onClose}>{t("cancel")}</Button>

				<Button variant="contained" color="primary" onClick={onConfirm}>
					{confirmText ? confirmText : t("dashboard/yes")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};
